<script lang="ts" setup>
import {
	computed,
	defineAsyncComponent,
} from 'vue';

type Props = {
	name: string;
	color?: string;
	width?: number | string;
	height?: number | string;
}

const props = withDefaults(defineProps<Props>(), {
	width: 24,
	height: 24,
});

const iconComponent = computed(() => defineAsyncComponent((): any => import(
	`../assets/icons/components/${props.name}.vue`
)));

const iconColor = computed(() => {
	if (!props.color) return '';

	return `var(--${props.color})`;
});
</script>

<template>
	<svg
		v-qa="`icon-${name}`"
		class="icon"
		:style="{ color: iconColor }"
		viewBox="0 0 24 24"
		:width="width"
		:height="height || width"
		aria-hidden="true"
	>
		<g>
			<Component :is="iconComponent" />
		</g>
	</svg>
</template>
